import { render, staticRenderFns } from "./SubmitTicketButtonGroupDesktop.vue?vue&type=template&id=d56d20cc&scoped=true&"
import script from "./SubmitTicketButtonGroupDesktop.vue?vue&type=script&lang=ts&"
export * from "./SubmitTicketButtonGroupDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitTicketButtonGroupDesktop.vue?vue&type=style&index=0&id=d56d20cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56d20cc",
  null
  
)

export default component.exports